import Achievement from 'models/achievement/Achievement';

/**
 * Class representing a externally acquired achievement.
 * @extends Achievement
 */
export default class ExternallyAcquiredAchievement extends Achievement {}
